import { DeleteBlockMatchParams } from "../entities/deleteBlockMatchParams";
import { MatchRepository } from "../repositories/MatchRepository";

export class DeleteBlockMatch {
	constructor(private repository: MatchRepository) {}
	execute(params: DeleteBlockMatchParams): Promise<void> {
		return this.repository.deleteBlockMatch(params);
	}
}
